import React from 'react';
import { BRAND, PRODUCT, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="border-t-2 border-gold bg-ink" data-id="element-78" data-mp="3gfiuujlrgden">
      <div className="mx-auto max-w-3xl px-3 py-5 text-center sm:px-6" data-id="element-79" data-mp="3gh3q6bfwg0dk">
        <p className="text-[0.7rem] font-extrabold uppercase tracking-[0.12em] text-gold sm:text-[0.74rem]" data-id="element-80" data-mp="32pfgsfx1bq0a">
          © 2026 {BRAND} — Todos los Derechos Reservados.
        </p>
        <p className="mt-2 font-body text-[0.66rem] leading-snug text-blush/80 sm:text-[0.7rem]" data-id="element-81" data-mp="3ug3gdnj28nbu">
          {PRODUCT} es un producto educativo de {BRAND}. Los resultados dependen
          del tiempo de estudio, práctica, constancia y características de cada
          estudiante. El programa proporciona formación introductoria y no
          constituye una certificación oficial de dominio del idioma coreano.
        </p>
        <p className="mt-2 text-[0.7rem] text-white sm:text-[0.74rem]" data-id="element-82" data-mp="29xm24swmjcl7">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-gold underline underline-offset-2" data-id="element-83" data-mp="2ezutxlxrg8lq">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <p className="mt-1.5 text-[0.68rem] text-blush/70 sm:text-[0.72rem]" data-id="element-84" data-mp="3gc0ixoj3k29q">
          Términos y Condiciones • Política de Privacidad • Contacto
        </p>
      </div>
    </footer>;
}